import React, { Component } from 'react';

export class NotFound extends Component {
    state = {  }
    render() { 
        return ( 
            <h1 class="heading">Page not found.</h1>
         );
    }
}
 
